import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { DatetimeRangePickerComponent } from '@components/shared/datetime-range-picker/datetime-range-picker.component';
import {
  ShipmentInfoListTableComponent,
  ShipmentViewModel,
} from '../shipment-info-list-table/shipment-info-list-table.component';

@Component({
  selector: 'app-shipment-info-result',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCard,
    MatIconModule,
    DatetimeRangePickerComponent,
    ShipmentInfoListTableComponent,
  ],
  templateUrl: './shipment-info-result.component.html',
  styleUrl: './shipment-info-result.component.scss',
})
export class ShipmentInfoResultComponent {
  @Input({ required: true }) public shipmentList: ShipmentViewModel[] = [];
  @Input({ required: true }) public dateRangeFormGroup!: FormGroup;
  @Input() public resultHistoryFrom = '';
  @Input() public resultHistoryTo = '';
  @Input({ required: true }) public maxRangeMonths!: number;
  @Input() public routeLoading = false;
  @Input() public defaultFilters: { [key: string]: string | boolean | number } =
    {};
  @Input() public editableRole = false;

  @Output() public opened = new EventEmitter<ShipmentViewModel>();
  @Output() public statusGottenReady = new EventEmitter<string>();
  @Output() public statusInterrupted = new EventEmitter<string>();
  @Output() public searchRequested = new EventEmitter<void>();
  @Output() public exportRequested = new EventEmitter<void>();
}
